/**
 * The GenAI Studio mark — the same one the miniapp shows (`GenAILogo` in
 * genai-studio-v2), so the site and the embedded Generate flow don't disagree
 * about what GenAI Studio looks like.
 *
 * `r=96` rather than the miniapp's `r=300`: it renders at 32px, and 96 covers
 * that at 3x. The CDN has already produced a right-sized WebP, so render it
 * `unoptimized` — Next re-encoding it is a second lossy pass for no saving.
 */
export const GENAI_LOGO_URL = 'https://cdn-cms-uploads.picsart.com/cms-uploads/7f9e8f46-5914-4e7b-adcf-058ad4c9391c.webp?type=webp&to=min&r=96';
